import React from 'react';
import { Navbar } from '../Home/components/Navbar';
import { Footer } from '../Home/components/Footer';
import './StaticPages.css';

export const Privacy = () => {
  return (
    <div className="static-page-wrapper hero-bg-listing-creative">
      <Navbar dark={true} />
      
      <div className="static-page-hero">
        <h1 className="static-page-title">Privacy Policy</h1>
        <p className="static-page-subtitle">Last updated: January 2025</p>
      </div>

      <main className="static-page-content">
        <div className="static-page-container">
          <div className="legal-content">
            <section className="legal-section">
              <h2>1. Information We Collect</h2>
              <p>
                We collect information you provide directly to us, including your name, email address, 
                phone number, payment information, and any other information you choose to provide when 
                you create an account, book events, or contact us.
              </p>
            </section>

            <section className="legal-section">
              <h2>2. How We Use Your Information</h2>
              <p>We use the information we collect to:</p>
              <ul>
                <li>Provide, maintain, and improve our services</li>
                <li>Process transactions and send related information</li>
                <li>Send you technical notices, updates, and support messages</li>
                <li>Respond to your comments, questions, and customer service requests</li>
                <li>Communicate with you about products, services, and events</li>
                <li>Monitor and analyze trends, usage, and activities</li>
              </ul>
            </section>

            <section className="legal-section">
              <h2>3. Information Sharing</h2>
              <p>
                We do not share your personal information with third parties except as described in 
                this privacy policy. We may share information with event organizers to facilitate 
                your bookings, with service providers who assist in our operations, or when required 
                by law.
              </p>
            </section>

            <section className="legal-section">
              <h2>4. Data Security</h2>
              <p>
                We take reasonable measures to help protect your personal information from loss, theft, 
                misuse, unauthorized access, disclosure, alteration, and destruction. All payment 
                information is encrypted using industry-standard protocols.
              </p>
            </section>

            <section className="legal-section">
              <h2>5. Your Rights</h2>
              <p>
                You have the right to access, update, or delete your personal information at any time. 
                You can do this through your account settings or by contacting us directly.
              </p>
            </section>

            <section className="legal-section">
              <h2>6. Cookies</h2>
              <p>
                We use cookies and similar technologies to collect information about your browsing 
                activities and to personalize your experience. You can manage your cookie preferences 
                through your browser settings.
              </p>
            </section>

            <section className="legal-section">
              <h2>7. Contact Us</h2>
              <p>
                If you have any questions about this Privacy Policy, please contact us at{' '}
                <strong>privacy@hobi.com</strong>
              </p>
            </section>
          </div>
        </div>
      </main>

      <Footer />
    </div>
  );
};
